import React, { Component } from "react";
import { connect } from "react-redux";

// Components
import BodyWrap from "../../utils/BodyWrap";
import AdminLoginForm from "./AdminLoginForm";

// State
import { getContent } from "../../../store/actions/content";

class AdminLogin extends Component {
	static initialAction(store, props, translationKey = null) {
		let permalink = "admin-login";
		let res = store !== null ? getContent(permalink) : props.getContent(permalink);
		return res;
	}

	componentDidMount() {
		AdminLogin.initialAction(null, this.props);
	}

	render() {
		const { data } = this.props.content;

		return (
			<BodyWrap>
				<main className="content-bottom-margin">
					<div className="content-header centered">
						<h1>{!!data.id ? data.title : ""}</h1>
						<div className="page-text">{!!data.id ? data.content : ""}</div>
					</div>
					<AdminLoginForm />
				</main>
			</BodyWrap>
		);
	}
}

const mapStateToProps = state => {
	return {
		content: state.content
	};
};

export default connect(
	mapStateToProps,
	{ getContent }
)(AdminLogin);



// WEBPACK FOOTER //
// ./src/components/admin/login/AdminLogin.js